// Short, plain-language descriptions for the Reports > Team Members
// Overview columns and drill-down categories -- shown as a small hover
// tooltip (see reportsInfoTooltipSx) so a new user can hover a header/
// category and immediately understand what it means, no docs needed.
// One flat map: Overview's OVERVIEW_COLUMNS_LIST keys and the drill-down's
// CATEGORY_CONFIG keys overlap for the shared metrics (assigned, closed,
// responseTime, resolutionTime, firstResponseTime), so both places read
// off the same entry instead of drifting into two different wordings for
// the same concept. Kept deliberately short (2026-08-18, Rahim's ask) --
// one plain clause, no filler.
export const REPORTS_TOOLTIP_COPY = {
  member: "Who these stats belong to.",
  inboxUsageTime: "Time spent active in the Inbox.",
  messagesSent: "Messages this member has sent.",
  assigned: "Conversations assigned to this member.",
  closed: "Conversations this member closed.",
  reassignCount: "Times this member reassigned a conversation.",
  reassigned: "Conversations reassigned to someone else.",
  responseTime: "Average time to reply to a message.",
  resolutionTime: "Average time to close a conversation.",
  firstResponseTime: "Time to this member's first reply.",
  responseCount: "Replies within the selected response-time range.",
  resolutionCount: "Resolutions within the selected time range.",
  firstResponseCount: "First replies within the selected time range.",
};
